import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, withLatestFrom, filter, tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Action, Store } from '@ngrx/store';

import * as fromCopiesCurrActions from './curr.actions';
import { ImageCopy } from '@apps/bckp/domain/models';
import { CopyListDomainService } from '@apps/bckp/domain';
import { IAuroraState } from '@apps/aurora.state';

import {
    getCopiesCurrQueryString,
    getCopiesCurrIsDataValid
} from '../../bckp-copies.reducer';
import { BckpConstants } from '@apps/bckp/bckp.constants';
import { NotfGravity, NotificationService, NotifType } from '@common/services';

@Injectable({
    providedIn: 'root'
})
export class BckpCopiesCurrEffects
{
    constructor (
        private actions: Actions,
        private copyListDomainService: CopyListDomainService,
        private store: Store<IAuroraState>,
        private notificationService: NotificationService
    )
    {
    }

    bckpCopiesCurrODataRequested: Observable<Action> = createEffect(() =>
        this.actions.pipe(
            ofType(fromCopiesCurrActions.BckpCopiesCurrODataRequested),
            withLatestFrom(
                this.store.select(getCopiesCurrQueryString),
                this.store.select(getCopiesCurrIsDataValid),
                (_, qs, isDataValid) => ({
                    qs,
                    isDataValid
                })
            ),
            filter(({ isDataValid }) => !isDataValid),
            switchMap(({ qs }) =>
                this.copyListDomainService.getLatestCopies(qs)
                    .pipe(
                        map((copies: ImageCopy[]) =>
                            fromCopiesCurrActions.BckpCopiesCurrODataSucceeded({ copies })
                        ),
                        catchError(() =>
                            of(fromCopiesCurrActions.BckpCopiesCurrODataFailed())
                        ),
                    )
            )
        )
    );

    bckpCopiesCurrODataFailed = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromCopiesCurrActions.BckpCopiesCurrODataFailed),
                    tap(() =>
                        this.notificationService.notify(
                            [
                                'BACKUP.COPIES.CURR.NOTF.LIST.TITLE',
                                'BACKUP.COPIES.CURR.NOTF.LIST.MSGFAILED'
                            ],
                            NotfGravity.danger,
                            NotifType.SNACKBAR
                        )
                    )
                ),
        { dispatch: false }
    );

    bckpCopiesFilterApplied = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromCopiesCurrActions.BckpCopiesCurrFilterApplied),
                    tap((params: any) =>
                    {
                        this.store.dispatch(fromCopiesCurrActions.BckpCopiesCurrCleared());
                        this.store.dispatch(fromCopiesCurrActions.BckpCopiesCurrODataInitialized({
                            scrollSize: BckpConstants.QSCopiesTop,
                            filter: params.filter
                        }));
                    }),
                    tap(() =>
                        this.store.dispatch(fromCopiesCurrActions.BckpCopiesCurrODataRequested())
                    )
                ),
        { dispatch: false }
    );

}
